import { type Control } from "react-hook-form";
import { Checkbox } from "../Checkbox";
import { FormControl, FormField, FormItem, FormLabel } from "../Form";

interface ICheckbox {
  control: Control<any>;
  label?: string;
}

const CheckboxController = (props: ICheckbox) => {
  const { control, label } = props;
  return (
    <FormField
      control={control}
      name="setting"
      render={({ field: { value, onChange, ...field } }) => (
        <FormItem className="flex items-start space-x-3 space-y-0">
          <FormControl>
            <Checkbox {...field} checked={value} onCheckedChange={onChange} />
          </FormControl>
          {label ? (
            <div className="space-y-1 leading-none">
              <FormLabel>{label}</FormLabel>
            </div>
          ) : null}
        </FormItem>
      )}
    />
  );
};

export default CheckboxController;
